import { Button } from "components/ui/button";

import { campaignPublicUrl, SlugStatus } from "../constants/campaign-slug";
import { CAMPAIGN_LINK_COPY, SLUG_STATUS_COPY } from "../constants/messages";
import type { SlugAvailability } from "../hooks/use-slug-availability";
import { CampaignSlugField } from "./campaign-slug-field";

const STATUS_ID = "campaignSlug-status";

const STATUS_TONE: Record<SlugStatus, string> = {
  [SlugStatus.EMPTY]: "text-muted-foreground",
  [SlugStatus.INVALID]: "text-muted-foreground",
  [SlugStatus.CHECKING]: "text-muted-foreground",
  [SlugStatus.AVAILABLE]: "text-green-700",
  [SlugStatus.TAKEN]: "text-red-600",
  [SlugStatus.FAILED]: "text-red-600",
};

interface CampaignLinkBlockProps {
  availability: SlugAvailability;
}

export function CampaignLinkBlock({
  availability,
}: CampaignLinkBlockProps): JSX.Element {
  const { slug, status, retry } = availability;
  const statusText: string | null = SLUG_STATUS_COPY[status];
  const publicUrl: string | null =
    status === SlugStatus.AVAILABLE ? campaignPublicUrl(slug) : null;

  return (
    <div className="md:col-span-2">
      <CampaignSlugField />
      <div
        id={STATUS_ID}
        role="status"
        aria-live="polite"
        className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs"
      >
        {statusText && (
          <span className={`font-medium ${STATUS_TONE[status]}`}>
            {statusText}
          </span>
        )}
        {publicUrl && (
          <span className="break-all text-muted-foreground">{publicUrl}</span>
        )}
        {status === SlugStatus.FAILED && (
          <Button type="button" variant="outline" size="sm" onClick={retry}>
            {CAMPAIGN_LINK_COPY.retry}
          </Button>
        )}
      </div>
    </div>
  );
}
